// @flow

import { observer } from "mobx-react";
import React from "react";

import "./ShareMedia.scss";

export const openShareWindow = (url: string) => {
    const width = 600;
    const height = 300;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;

    const popup = window.open(
        url,
        "popupwindow",
        "scrollbars=yes" +
            ",width=" +
            width +
            ",height=" +
            height +
            ",top=" +
            top +
            ",left=" +
            left
    );

    popup.focus();
};

type Props = {
    title: string,
    url: string,
    type: string
};

@observer
export default class ShareMedia extends React.Component<Props> {
    static types: { [_: string]: Function } = {};

    static pushType(type: string, component: Function) {
        ShareMedia.types[type] = component;
    }

    render() {
        return <div className="ShareMedia">{this.renderByType()}</div>;
    }

    renderByType() {
        const type = this.props.type;
        let typeClass = ShareMedia.types[type];

        if (!typeClass) {
            console.warn(type + " share type not supported");
            return null;
        }

        return React.createElement(typeClass, this.props);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ShareMedia/ShareMedia.js